import React, { useState, useEffect, useRef } from 'react'
import axios from "axios";
import { APIURL } from "../../../Global";
import printJS from 'print-js'
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import moment from 'moment'
import { useAlert } from "react-alert";
import pv from "../../../assets/images/ft_logo.png";
import { useApiContext } from "../../contexts/ApiContext";
function PaymentInvoiceLiability(props) {
  const { setIsApiSuccess } = useApiContext();
  // console.log(invoiceData,"invoiceData")
  const [due, setDue] = useState(props.due)
  const [totalOrderAmount, settotalOrderAmount] = useState(0)
  const [invoiceData, setInvoiceData] = useState([]);
const sel=props.selected
  const [isSaving, setIsSaving] = useState(false);
  const [method, setMethod] = useState('')
  const [payment_to, setpayment_to] = useState('full_pay')
  const alert = useAlert();
  const [paidAmt, setPaidamt] = useState(null)
  const [discount, setDiscount] = useState(0.0);
  const [discountAmt, setDiscountAmt] = useState(0.0);
  const [Ids, setID] = useState([]);
  const [error, setError] = useState({})
  const [reference, setreference] = useState("")
  const [remarks, setRemarks] = useState("")
  const [showreference, setShowreference] = useState(false)
  // const html2pdf = require('html2pdf.js');
  const [login_datas, setLogin_datas] = useState(
    JSON.parse(sessionStorage.getItem("logindatas"))
      ? JSON.parse(sessionStorage.getItem("logindatas"))
      : null
  );
  const [infoShow, setinfoShow] = useState(false)
  const [infoData, setInfoData] = useState('')
  useEffect(() => {

    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '')

    axios.get(
      `${APIURL}/api/v1/staff/hospital-license-bills/?bill_type=${props.selected}`, {
      params: { 'bill_ids': props.id },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + str,
      }
    })
      .then(res => {

        if (res.data.status === "success") {
          setInvoiceData(res.data.message)

        }


      })
      .catch(err => {

      })


  }, []);

  useEffect(() => {
    if (payment_to !== "full_pay") {
      setDiscount(0)
    } else if (payment_to !== "part_pay") {
      setPaidamt(null)
    }
  }, [payment_to])
  const handleMethod = (e) => {
    setMethod(e.target.value)
    if (e.target.value === "upi" || e.target.value === "cash") {
      setShowreference(true)
      // setError((currentstate) => ({
      //   ...currentstate,
      //   reference: 'Enter payment reference',
      // }))
    }
    // else if(payment_to === "part_pay"&&(paidAmt===null||paidAmt<1)){
    //   setError((currentstate) => ({
    //     ...currentstate,
    //     paidAmt: 'Enter amount',
    //   }))
    // }
    else {
      setShowreference(false)
      setError((currentstate) => ({
        ...currentstate,
        reference: '',
      }))
    }
  }

  const handleSave = async () => {
    document.getElementById("save-btn").disabled = true;

    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '');
    if (payment_to !== "waived" && reference === "") {
      setError((currentstate) => ({
        ...currentstate,
        reference: 'Enter reference',
      }))
    }
    else if (payment_to === "part_pay" && (paidAmt === null || paidAmt < 1)) {
      setError((currentstate) => ({
        ...currentstate,
        paidAmt: 'Enter amount',
      }))
    }
    else if (payment_to === "part_pay" && (paidAmt === null || paidAmt < 1)) {
      setError((currentstate) => ({
        ...currentstate,
        paidAmt: 'Enter amount',
      }))
    }
    else {
      const dataToUpdate = {
        bill_ids: props.id,
        hospital_id: props.hospId,
        "payment_mode": {
          method: method,
          "payment_reference": reference
        },
        paid_amount: payment_to === "waived" ? 0 : payment_to === "part_pay" ? Number(paidAmt) : Number(due),
        waived_off: payment_to === "waived" ? true : false,
        patient_id: props.patid,
        bill_discount_percent: discount && discount !== "" ? parseFloat(discount).toFixed(2) : parseFloat(0).toFixed(2),
        bill_discount_amount: discountAmt && discountAmt !== "" ? parseFloat(discountAmt).toFixed(2) : parseFloat(0).toFixed(2),
        remarks: remarks

      }

      if (isSaving) {
        return;
      }
      setIsSaving(true);
      try {
        const res = await axios.post(`${APIURL}/api/v1/staff/hospital-license-payment/`, dataToUpdate,
          {
            headers: {
              'Content-Type': 'application/json',
              "Authorization": 'Token ' + str
            }
          })
          .then(res => {

            if (res.data.status === "success") {
              alert.success(res.data.message)

              handlePrint()
            } else {
              alert.error(res.data.message)
            }

          })
      } catch (err) {
        alert.error('Error in Data Submission.Please try again')

      }
      finally {
        setIsSaving(false);
      }
      document.getElementById("save-btn").disabled = false;
    }
  }


  const handlePrint = () => {

    window.print()
    setIsApiSuccess(true);
    props.onSuccess()
  };

  const handleInfoPopUp = (item) => {
    setInfoData(item);
    setinfoShow(true);
  }

  const InfoPopup = (props) => {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false} >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"><h5> {infoData.item_name.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <div>

            <fieldset className='field_set'>

              <legend style={{ size: "5" }}>

                <div className="row-of-features">
                  <div className="col-of-features">

                  {sel !== "plan" ?<h6>&nbsp;&nbsp;&nbsp;Bill Cycle:&nbsp;{infoData.plan_start_date} to {infoData.plan_end_date}</h6>:
                  <h6>&nbsp;&nbsp;&nbsp;Plan start date:&nbsp;{infoData.plan_start_date} </h6>}

                  </div>
                </div>




              </legend>


            </fieldset>
          </div>



        </Modal.Body>

      </Modal>
    );
  }
  useEffect(() => {
    console.log("invoiceData", invoiceData)
    let totalAmount = invoiceData.reduce((accumulator, item) => {
      console.log(item)
      const discountedAmount = (item.total_license_amount)

      console.log((accumulator + item.total_amount))
      return (accumulator + item.amount);
    }, 0);
    let totalAmountDue = invoiceData.reduce((accumulator, item) => {

      return (accumulator + item.amount_without_gst);
    }, 0);
    let finalTotal = props.due
    if (discount > 0) {
      finalTotal = (due) - (invoiceData[0].amount * discount / 100);
    }
    else if (discountAmt > 0) {
      finalTotal = (due) - discountAmt;
    }
if(finalTotal<0){
  // settotalOrderAmount(totalAmount)
    setDue(props.due);
    setDiscount("")
}
else{
  settotalOrderAmount(totalAmount)
    setDue(parseFloat(finalTotal.toFixed(2)));
}
  

  }, [invoiceData, discount, discountAmt]);
  const handlePayement = (e) => {
    setpayment_to(e.target.value)
  }
  return (<div >
    <style>
      {`
    @media print {
        body {
            margin: 0;
            padding: 0;
        }
       
        /* Hide everything else */
        body * {
            visibility: hidden;
        }
       
        /* Ensure only the printable content is visible */
        .print\\:block, .print\\:block * {
            visibility: visible;
        }
       
        /* Make the print content take up the full page */
        .print\\:block {
            position: absolute;
            left: -25vw;
            top: -200px;
            width: 100vw; /* Full viewport width */
            height: 100vh; /* Full viewport height */
            transform: scale(1); /* Increase size (adjust as needed) */
            transform-origin: top left;
            margin: 0;
            padding: 0;
        }
 
        /* Ensure colors are printed correctly */
        * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
 
        /* Remove default margins */
        @page {
            size: A4 portrait; /* or landscape if needed */
            margin: 0;
          }
        }
      `}
    </style>
    <div className='print:block' style={{ padding: '4%', }}>

      <div className='row' >
        <div className='col-9'>
          <div style={{ display: "flex", }}><img src={pv} width="15%" height="15%" alt="image" />&nbsp;&nbsp;</div>
          <div style={{ textAlign: "left" }}>

          </div>
        </div>

        <div className='col-2'>
          <h2 style={{ color: "blue" }} className="title-of-tasks"> INVOICE  </h2>
        </div>
      </div><br />
      <div className='row' style={{ marginBottom: "1%", margin: "auto" }}>
        <div className='col-10'>
          <div className='det-div row' style={{ width: "100%", paddingTop: "0.5rem" }} >

            <div className="col-4">
              <input
                type="radio"
                id="full_pay"
                name="payment_to"
                value="full_pay"
                checked={payment_to === "full_pay"}
                onClick={handlePayement}
              />&nbsp;
              <label style={{ fontSize: "small" }} htmlFor="full_pay">Full payment</label>

            </div>

           <div className="col-4">
             <input
             disabled={props.selected==="credits"}
               type="radio"
               id="part_pay"
               name="payment_to"
               value="part_pay"
               checked={payment_to === "part_pay"}
               onClick={handlePayement}
             />&nbsp;
               <label style={{fontSize:"small"}} htmlFor="part_pay">Partial payment</label>
             

           </div>
           <div className="col-4">
             <input
              disabled={props.selected==="credits"}
               type="radio"
               id="waived"
               name="payment_to"
               value="waived"
               checked={payment_to === "waived"}
               onClick={handlePayement}
             />&nbsp;
               <label style={{fontSize:"small"}} htmlFor="waived">waived off</label>
            

            </div>
          </div>


        </div>
        <div className='col-2'>
          <div style={{}}>
            <small className="invoice-heading invoice-heading-normal">Date</small><br />
            <small className="invoice-heading invoice-heading-normal"> {moment().format('DD-MM-YYYY')}</small>

          </div>


        </div>
      </div>
      <div className='row' >
        <div className='col-8'>
          <div style={{ marginBottom: "1%", fontSize: "15px", textAlign: "left", padding: "1%" }} className='row'>
          {invoiceData.length > 0 && invoiceData.map((item, i) => {
            return(<>
              <div style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", border: "1px solid white", }} className="col-6"><div style={{ padding: "1%" }}> Item/Service </div></div>
              <div style={{ backgroundColor: "rgb(237 236 224)", border: "1px solid white", }} className="col-6"><div style={{ padding: "1%" }}>{props.selected === "special_feature" ? item.item_name.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()) : item.item_name}&nbsp;
                {(props.selected !== "credits" && props.selected !== "special_feature") && <svg onClick={(e) => { handleInfoPopUp(item) }} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 1024 1024"><path fill="rgba(85, 71, 159, 0.72)" d="M512 64a448 448 0 1 1 0 896.064A448 448 0 0 1 512 64m67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344M590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.99 12.99 0 0 1-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296c-44.096 0-108.992 44.736-148.48 101.504c0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 0 1 7.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04c67.84 0 107.904-43.648 147.456-100.416z" /></svg>}</div></div>
                {(props.selected !== "credits" && props.selected !== "special_feature") && <><div style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", border: "1px solid white", }} className="col-6"><div style={{ padding: "1%" }}> Issued Date</div></div>
                <div style={{ backgroundColor: "rgb(237 236 224)", border: "1px solid white", }} className="col-6"><div style={{ padding: "1%" }}>{item.bill_generated_date}</div></div>
                </>}
                {props.selected !== "plan" &&<><div style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", border: "1px solid white", }} className="col-6"><div style={{ padding: "1%" }}>Qty</div></div>
                <div className="col-6"style={{ backgroundColor: "rgb(237 236 224)", border: "1px solid white", }}><div style={{ padding: "1%" }}>{item.quantity}</div></div>
                </>}
                <div style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", border: "1px solid white", }} className="col-6"><div style={{ padding: "1%" }}>{props.selected === "credits" ? "Amount" : props.selected === "special_feature" ? "Feature Amount" : "License Amount"}</div></div>
                <div style={{ backgroundColor: "rgb(237 236 224)", border: "1px solid white", }} className="col-6"><div style={{ padding: "1%" }}>{item.amount_without_gst.toFixed(2)}</div></div>
                
                <div style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", border: "1px solid white", }} className="col-6"><div style={{ padding: "1%" }}>GST</div></div>
                <div style={{ backgroundColor: "rgb(237 236 224)", border: "1px solid white", }} className="col-6">
                <div style={{ padding: "1%" }}>18%</div>
              </div>
              {payment_to === "full_pay" &&<> <div style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", border: "1px solid white", }} className= "col-6"><div style={{ padding: "1%" }}>Discount</div></div>
              <div style={{ backgroundColor: "rgb(237 236 224)", border: "1px solid white", }} className="col-6">
                {invoiceData[i].discount && invoiceData[i].discount !== "" ? <div style={{ padding: "1%" }} >{item.discount}</div> :
                  <div style={{ display: "flex" }}> <input
                    className={`${error.discount && error.discount !== "" ? 'error-border' : 'clinc_input'}`}
                    type="number"
                    maxLength="100"
                    placeholder="in %"
                    value={discount === 0.0 ? null : discount}
                    style={{ width: "49%" }}
                    onChange={(e) => {
                      setDue(props.due)
                      setDiscount(e.target.value)
                      setDiscountAmt(0)
                      if (e.target.value !== "" && (e.target.value < 0 || e.target.value > 100.1)) {
                        setError((currentState) => ({
                          ...currentState,
                          discount: "Enter count",
                        }));
                      }
                      else {
                        setError((currentState) => ({
                          ...currentState,
                          discount: "",
                        }));
                      }
                    }}

                  />&nbsp;
                    <span style={{ paddingTop: "2%" }}>OR</span>&nbsp;
                    <input
                      className={`${error.discountAmt ? 'error-border' : 'clinc_input'}`}
                      type="number"
                      maxLength="100"
                      placeholder="in amount"
                      value={discountAmt === 0.0 ? null : discountAmt}
                      style={{ width: "49%" }}

                      onChange={(e) => {
                        setDue(props.due)
                        setDiscountAmt(e.target.value)
                        setDiscount(0)
                        if (e.target.value !== "" && (e.target.value < 0 || e.target.value > props.due)) {
                          setDiscountAmt("")
                          setError((currentState) => ({
                            ...currentState,
                            discountAmt: "Enter count",
                          }));
                        }
                        else {
                          setError((currentState) => ({
                            ...currentState,
                            discountAmt: "",
                          }));
                        }

                      }}
                    />
                  </div>}
              </div>
              </>}
              {payment_to === "part_pay" &&<> <div style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", border: "1px solid white", }} className= "col-6"><div style={{ padding: "1%" }}>Paid amount</div></div>
              <div style={{ backgroundColor: "rgb(237 236 224)", border: "1px solid white", }} className="col-6">
                <input
                  type="number"
                  maxLength="50"
                  name="discount"
                  className={`input1 ${error.paidAmt ? 'error-border col-8' : 'clinc_input col-8'}`}
                  // style={{
                  //   border: "1px solid #CCCCCC",
                  //   borderRadius: " 8px",
                  //   // width: "60%",
                  // }}
                  value={paidAmt}
                  onChange={(e) => {
                    document.getElementById("save-btn").disabled = false;
                    setPaidamt(e.target.value > 0 && e.target.value < due ? e.target.value : alert.error("invalid amount"))

                  }}
                /></div>
              </>}
        
                </>)
          })}
          </div>
        </div>
       
        <div className='col-4  clinc_input' style={{ margin: "auto" }}>
          <div className='row'>
            <span style={{ textAlign: "left" }} className='text-muted  col-12'> Total</span>
            <span className="col-12" style={{ fontSize: "14px", textAlign: "left" }}><span className=""><b>RS{" "}</b></span><b>{totalOrderAmount.toFixed(2)}/-</b></span>
          </div><br />
          <div className='row' style={{ marginTop: "2%" }} >
            <span style={{ textAlign: "left" }} className='text-muted col-12'> Paid</span>
            <span className="col-12" style={{ color: "green", fontSize: "14px", textAlign: "left" }}><span className=""><b>RS{" "}</b></span><b>{props.paid}/-</b></span>
          </div>
          <br />
          <div className='row' style={{ marginTop: "2%" }}>
            <span style={{ textAlign: "left" }} className='text-muted col-12'>Payable</span>
            <span className="col-12" style={{ color: "orange", fontSize: "18px", textAlign: "left" }}><b >RS{" "}{due.toFixed(2)}/-</b></span></div>
        </div>
      </div>
    </div>
    <div className='row'>
      <div className='col-8'>
        <div className='flex-row invoice-radio' style={{ paddingLeft: "2%" }}>

          <input type='radio' className='hideme' checked={method === 'cash'} id='cash' value='cash' onChange={handleMethod} />
          <label htmlFor='cash' className='invoice-label'>
            Bank
          </label>
          &nbsp;&nbsp;
          <input type='radio' className='hideme' checked={method === 'upi'} id='benefit_pay' value='upi' onChange={handleMethod} />
          <label htmlFor='benefit_pay' className='invoice-label'>
            UPI
          </label>
        </div>
        {showreference && <div className='row' style={{ width: "100%" }}>  <span className='text-muted font-weight-bold col-4'></span> <input

          type="text"
          maxLength="50"
          placeholder={method === "upi" ? 'Enter payment reference' : "Enter transaction reference"}
          name="payment_reference"
          className={`input1 ${error.reference ? 'error-border col-8' : 'clinc_input col-8'}`}
          value={reference}
          onChange={(e) => {
            document.getElementById("save-btn").disabled = false;
            setreference(e.target.value);
            if (e.target.value !== "") {
              setError((currentstate) => ({
                ...currentstate,
                reference: '',
              }))
            }
            else {
              setError((currentstate) => ({
                ...currentstate,
                reference: 'Enter reference',
              }))
            }

          }}
        /></div>}

        <div className='row' style={{ width: "100%", marginTop: "1%" }}>  <span className='text-muted font-weight-bold col-4'></span>
          <textarea

            type="text"
            maxLength="50"
            placeholder='Remarks'
            name="remarks"
            className={'clinc_input col-8'}
            value={remarks}
            onChange={(e) => {
              document.getElementById("save-btn").disabled = false;
              setRemarks(e.target.value);




            }}
          /></div>
      </div>
      <div className='col-4'>
        <button className="btn btn-primary btn-col btn-square" id="save-btn" onClick={() => { if (payment_to !== "waived" && method === '') { alert.error("select payment method") } else { handleSave() } }}> Save and Print </button>
      </div>
    </div>
    <br />
    <div className="do-not-print text-center" id="pr">


      <small style={{ color: "grey" }}>** If in case 'Print' does not work, please cross check if popup blocker is switched 'off' in your Browser settings.</small>

    </div>


    {
      infoShow ?
        <InfoPopup
          show={infoShow}
          onHide={() => {
            setinfoShow(false);
          }}

        /> : ''
    }

  </div>
  )
}

export default PaymentInvoiceLiability
